module.exports = __webpack_public_path__ + "assets/img/b454b4879f08745a275579209d6f15fb.png";